module.exports = "<div class=row> <ul id=ul-veld2> <li class=fieldButton ng-repeat=\"field in ::fields\"> <a ui-sref=\"leerinhoud.field({fieldKey: field.identifiers[0]})\" ng-style=::field.style title={{::field.title}} alt={{::field.title}}> <img ng-src={{::field.iconUrl}} height=20 width=20> </a> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/field-picker/fieldPicker.html
// module id = 1076
// module chunks = 0